import type { FileRouteTypes } from '~/routeTree.gen'

type AppRoute = FileRouteTypes['fullPaths']

export function absoluteUrl(path: AppRoute): string {
  return new URL(path, window.location.origin).toString()
}
